import api from './api'

const BASE = '/partner-licensings/:partnerLicensingId/stalls'

export default {
  all() {
    return api.get(`${BASE}/all`)
  },

  create(body) {
    return api.post(BASE, body)
  },

  update(id, body) {
    return api.put(`${BASE}/${id}`, body)
  },

  transferAnimals(transfers) {
    return api.put(`${BASE}/animals`, { transfers })
  },

  history(stallId, params = {}) {
    return api.get(`${BASE}/${stallId}/history`, { params })
  },
}
